module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hX8h4T/images/cover.jpg?1685327252450",
      "alt": "This image is the cover for the book His Soul to Take"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("His Soul to Take\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Simon has waited centuries for someone like Robert, but their first meeting is intended to be their last: Robert’s time on Earth is up, and it is Simon’s place to take him out of this world and into the next. Instead, Simon makes a split-second decision to save Robert’s life, though he is uncomfortably aware he has only postponed the inevitable.")]), _vm._v(" "), _c('p', [_vm._v("Robert quickly falls for Simon, but when he notices the way Death seems to follow him around, his curiosity about Simon’s true nature turns to suspicion, all but erasing his memories of the man. Simon must fight to make him remember… and to stop Robert from making a grisly mistake.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      C.M. Torrens\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0